import clsx from "clsx";
import { useCallback } from "react";
import { Link, useLocation } from "react-router-dom";

import { useHasSomeRoles } from "../../util";
import { VDiv } from "../Div";

export type NavItem = {
  name: string;
  icon: string;
  pathname: string;
};

interface NavSectionProps {
  title: string;
  items: NavItem[];
  onNavLinkClick?: () => void;
}

const NavSection = ({ title, items, onNavLinkClick }: NavSectionProps) => {
  const { data: isAdminOrStaff } = useHasSomeRoles(["admin", "staff"]);
  const { pathname } = useLocation();
  const showAdminStyle =
    isAdminOrStaff &&
    (pathname.includes("admin") || pathname.includes("user-profile"));

  const getLinkClasses = useCallback(
    (route: string) => {
      const newPathname = pathname.replace(/\/+$/, "");
      const isActive = newPathname === route;

      return clsx(
        "items-center px-3 py-2 rounded-lg w-full",
        "cursor-pointer text-sm overflow-hidden hover:bg-secondary-light",
        {
          "text-secondary-medium hover:text-primary":
            !isActive && showAdminStyle,
          "text-primary": isActive || !showAdminStyle,
          "bg-secondary-light border border-primary-dark": isActive,
        },
      );
    },
    [pathname, showAdminStyle],
  );

  return (
    <VDiv
      className={`gap-1 text-xs ${
        showAdminStyle ? "text-secondary-medium" : "text-secondary"
      }`}
    >
      {title.toUpperCase()}
      {items.map((item) => (
        <Link
          to={item.pathname}
          key={item.name}
          className={getLinkClasses(item.pathname)}
        >
          <div onClick={onNavLinkClick}>
            <i className={`fa-regular ${item.icon} pr-2`}></i>
            {item.name}
          </div>
        </Link>
      ))}
    </VDiv>
  );
};

export default NavSection;
